import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Collapse,
  ListGroup,
  ListGroupItem,
  Tooltip
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import '../../assets/css/CompanyCardStyle.css';
import { REQUEST_HEADERS, IMAGE_PREFIX_URL, COMPANY_URL } from '../../constants.js';
import business_profile from '../../assets/images/business_profile.png';
import CompanyNewOrEditModal from './CompanyNewOrEditModal.jsx';
import CompanyCircles from './CompanyCircles.jsx';
import axios from 'axios';

const CompanyCard = (props) => {
  const {
    showOpenInNewTab,
    renderCollapsed
  } = props;

  const [companyData, setCompanyData] = useState(props.data);
  const [isOpen, setIsOpen] = useState(!renderCollapsed);
  const [isDeleted, setIsDeleted] = useState(false);

  const {
    name,
    sector,
    business_activity: businessActivity,
    image,
    main_activity: mainActivity,
    main_products: mainProducts,
    circle_skills: circleSkills,
    address,
    contact,
    born_at,
  } = companyData;

  const {
    month,
    year,
    day
  } = born_at;

  const date = born_at != null && born_at !== ''
    ? `${day <= 9 ? '0' : ''}${day}/${month <= 9 ? '0' : ''}${month}/${year}`
    : null;

  const {
    area,
    email,
    office_phone: officePhone,
    mobile_phone: mobilePhone,
    website
  } = contact;

  const isAdmin = true;

  const getImageURL = () => {
    return image != null && image.path != null
      ? `${IMAGE_PREFIX_URL}${image.path}.${image.extension}?lastUpdated=${image.last_updated}`
      : business_profile;
  }

  return isDeleted ? null : (
    <Card className="company-card">
      <CardTitle className="company-card-title text-uppercase">
        {isAdmin ?
          <AdminEditButtons
            data={companyData}
            onUpdate={(data) => setCompanyData(data)}
            onDelete={() => setIsDeleted(true)} />
          : null
        }
        {showOpenInNewTab ? <ShareButton uuid={companyData.uuid} /> : null}
        <Row>
          <Col md={2}>
            <img
              alt="logo"
              className="rounded-circle company-card-logo"
              src={getImageURL(image)} />
          </Col>
          <Col md={10}>
            <h4>{name}</h4>
          </Col>
        </Row>
      </CardTitle>
      <CardBody>
        <Row className="company-card-body">
          <Col sm={6}>
            <Row>
              <Col>
                <CompanySingleTextInformation
                  label={'Fecha de Inicio de Actividades'}
                  data={date} />
                <CompanySingleTextInformation
                  label={'Sector'}
                  data={sector} />
                <CompanySingleTextInformation
                  label={'Giro'}
                  data={businessActivity} />
              </Col>
              <Col>
                <CompanySingleTextInformation
                  label={'Actividad Principal'}
                  data={mainActivity} />
                <CompanySingleTextInformation
                  label={'Dirección'}
                  data={address} />
              </Col>
            </Row>
            <Collapse isOpen={isOpen}>
              <Row>
                <Col>
                  <h6 className="text-uppercase company-card-single-text-label">
                    Productos o Servicios Principales
                  </h6>
                  <ProductOrServicesInformation products={mainProducts ?? []} />
                </Col>
              </Row>
            </Collapse>
          </Col>
          <Col sm={6}>
            <h6 className="text-uppercase company-card-single-text-label">
              Grado de Confiabilidad
            </h6>
            <CompanyCircles circleSkills={circleSkills} />
          </Col>
        </Row>
        <Collapse isOpen={isOpen}>
          <Row className="company-card-subtitle">
            <h6>Datos de Contacto</h6>
          </Row>
          <Row className="company-card-body">
            <Col sm={4}>
              <CompanySingleTextInformation
                label={'Área de Contacto'}
                data={area} />
              <CompanySingleTextInformation
                label={'Email'}
                data={email} />
            </Col>
            <Col sm={4}>
              <CompanySingleTextInformation
                label={'Teléfono'}
                data={officePhone} />
              <CompanySingleTextInformation
                label={'Celular'}
                data={mobilePhone} />
            </Col>
            {website != null && website !== ''
              ? <Col sm={4}>
                <CompanyURLInformation
                  label={'Sitio Web'}
                  data={website} />
              </Col>
              : null
            }
          </Row>
        </Collapse>
        <Row>
          <Col className="company-card-see-more" sm={{ offset: 5 }}>
            <CollapseCardButton
              isOpen={isOpen}
              setIsOpen={setIsOpen} />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

const CompanySingleTextInformation = (props) => {
  const {
    label,
    data
  } = props;
  return (
    <Row style={{ paddingRight: "10px" }}>
      <Col>
        <h6 className="text-uppercase company-card-single-text-label">
          {label}
        </h6>
        <p className="company-card-single-text-data">{data ?? 'N/A'}</p>
      </Col>
    </Row>
  );
}

const CompanyURLInformation = (props) => {
  const {
    label,
    data
  } = props;
  return (
    <Row>
      <a href={data} target="_blank" rel="noopener noreferrer">
        <h6 className="text-uppercase company-card-single-text-link">
          {label}
        </h6>
      </a>
    </Row>
  );
}

const CollapseCardButton = (props) => {
  const {
    isOpen,
    setIsOpen
  } = props;
  return (
    <Button
      color="link"
      size="sm"
      onClick={() => setIsOpen(!isOpen)} >
      {!isOpen ? 'Ver Más' : 'Ver Menos'}
      <i className={`fa ${!isOpen ? 'fa-caret-down' : 'fa-caret-up'} view-more-icon`} />
    </Button>
  );
}

const ProductOrServicesInformation = (props) => {
  const { products } = props;
  return (
    <ListGroup>
      {
        products.map(
          (product, index) =>
            <ListGroupItem
              className="company-card-product-item company-card-single-text-data"
              key={'product_or_service_' + index}>
              {product}
            </ListGroupItem>
        )
      }
    </ListGroup>
  );
}

const AdminEditButtons = (props) => {
  const { isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    return null;
  }

  const {
    data,
    onUpdate,
    onDelete
  } = props;

  const deleteCompany = () => {
    axios({
      url: COMPANY_URL + '/' + data.uuid,
      method: 'DELETE',
      headers: REQUEST_HEADERS
    }).then(() => {
      onDelete();
    });
  }

  return (
    <Row>
      <Col xs={{ offset: 9, size: 1 }} className="company-admin-btn-edit">
        <CompanyNewOrEditModal companyData={data} onUpdate={onUpdate} />
      </Col>
      <Col xs={1} className="company-admin-btn-delete">
        <Button color="danger" size="sm" onClick={deleteCompany}>
          <i className="fa fa-trash" />
        </Button>
      </Col>
    </Row>
  );
}

const ShareButton = (props) => {
  const { uuid } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const target = `share-button-${uuid}`;
  return (
    <Row>
      <Col md={{ offset: 11, size: 1 }}>
        <Button size="lg" color="link">
          <Link to={`/company/shareable-card/${uuid}`}>
            <i className="fa fa-external-link" id={target} />
          </Link>
        </Button>
        <Tooltip placement="bottom" isOpen={tooltipOpen} target={target} toggle={toggle}>
          Abrir en nueva pestaña
        </Tooltip>
      </Col>
    </Row>
  );
}

export default CompanyCard;
